module.exports = require("npm:validator@5.2.0/index.js");